import React from "react";
import styles from "./Hero.module.scss";
import Image from "next/image";
import Link from "next/link";

const Hero = () => {
  return (
    <section className={styles.heroSection}>

      <div className={styles.container}>
      <div className={styles.blobBottom} />
      <div className={styles.blobMiddle} />
      <div className={styles.content}>
        <h1 className={styles.title}>
          Spread Love,
          <br />
          <span className={styles.spanTitle}>Earn Rewards.</span>
        </h1>
        <p className={styles.paraghraph}>
          A smartphone app that lets you stake BLV tokens, invite referrals and
          earn lovely rewards.
        </p>

        <p className={styles.paraghraphDownload}>Download B-love Network:</p>
        <Link
          target="_blank"
          href={
            "https://play.google.com/store/apps/details?id=biz.innovationfactory.bnetwork&hl=en_US&pli=1"
          }
        >
          <button className={styles.btn}>Download App</button>
        </Link>
      </div>
      <div className={styles.sectionImage}>
        <Image
          src="/assets/Image/im-0023.png"
          width={632}
          height={1000}
          className={styles.image}
          alt=""
        />
      </div>
      </div>
    </section>
  );
};

export default Hero;
